import React, { useMemo } from "react";
import FocusPagerAndroid from "./FocusPagerAndroid";
import FocusPagerIOS from "./FocusPagerIOS";

const isIOSDevice = () => {
  if (typeof navigator === "undefined") return false;

  const userAgent = navigator.userAgent || "";
  const platform = navigator.platform || "";
  const maxTouchPoints = navigator.maxTouchPoints || 0;

  return (
    /iPad|iPhone|iPod/i.test(userAgent) ||
    (platform === "MacIntel" && maxTouchPoints > 1)
  );
};

const FocusPager = (props) => {
  const useIOSMethod = useMemo(() => isIOSDevice(), []);

  return useIOSMethod ? (
    <FocusPagerIOS {...props} />
  ) : (
    <FocusPagerAndroid {...props} />
  );
};

export default FocusPager;